import ProductCreationParameters from './product-creation-parameters';
import Product from '../../model/product/product';
import ProductPlacement from '../../model/product/product-placement';

export default abstract class ProductFactory<
  P extends ProductCreationParameters
> {
  public createProduct(parameters: P): Product {
    const toReturn = this.createProductTemplate(parameters);
    toReturn.productPlacement = this.createProductPlacement();
    return toReturn;
  }

  protected abstract createProductTemplate(parameters: P): Product;

  protected abstract createProductPlacement(): ProductPlacement;

  abstract getProductCreationParameters(parameters: any): P;
}
